import React from 'react';
import {
  ProjectData,
  PropertyPageInitialProps,
  PropertyPageProps,
} from '../../lib/propertyTypes';
import config from '../../common/config';
import ProjectPage from '../projectPage/ProjectPage';
import { transformProjectnetProjectData } from '../../common/helpers/data/transformProjectnetProjectData';
import { extractPropertyTypeFromProjectData } from '../../common/helpers/utility/extractPropertyType';
import { isNull } from 'lodash';
import {
  fetchNearbyProjects,
  fetchProjectArticles,
  fetchProjectData,
} from '../../services/projectnetProject';
import logger from '../../common/helpers/logger/logger';

function PropertyPage({
  projectData,
  error,
  nearbyProjectData,
  projectArticleData,
  canonicalLink,
}: PropertyPageProps) {
  const transformedNearbyProjectData =
    nearbyProjectData?.data.map((item: ProjectData) =>
      transformProjectnetProjectData(item),
    ) || [];
  const transformedData = {
    data: {
      loading: false,
      project: projectData && transformProjectnetProjectData(projectData),
      error: error,
    },
    nearbyProjectData: {
      otherNearbyProjectData: {
        items: transformedNearbyProjectData,
      },
    },
    projectArticleData: projectArticleData,
    canonicalLink: canonicalLink,
  };
  return <ProjectPage {...transformedData} />;
}

PropertyPage.getInitialProps = async ({
  query,
  res,
  asPath,
  apolloClient,
}: PropertyPageInitialProps) => {
  const { property_id, property_type } = query as Partial<PropertyPageProps>;
  const canonicalLink = config.baseUrl + asPath.substring(1);

  let projectData = null;
  let nearbyProjectData: { data: ProjectData[] } = { data: [] };
  let projectArticleData = {};
  let error = null;

  try {
    // Fetch project data first
    projectData = await fetchProjectData(property_id);

    if (projectData && !isNull(projectData)) {
      const actualPropertyType =
        extractPropertyTypeFromProjectData(projectData);

      if (
        actualPropertyType &&
        actualPropertyType.toLowerCase() !== property_type.toLowerCase()
      ) {
        res.writeHead(302, {
          Location: `/project/${encodeURIComponent(
            actualPropertyType.toLowerCase(),
          )}/${encodeURIComponent(property_id)}`,
        });
        res.end();
        return {};
      }

      const districtCode = projectData.district_code;

      [nearbyProjectData, projectArticleData] = await Promise.all([
        districtCode
          ? fetchNearbyProjects(districtCode, parseInt(property_id))
          : Promise.resolve(null),
        fetchProjectArticles(apolloClient, {
          projectNetPropertyId: parseInt(property_id),
        }),
      ]);
    }
  } catch (err) {
    error = err.message;
    logger.logError('PropertyPage.getInitialProps', 'Error fetching data', {
      error,
    });
  }

  return {
    projectData,
    nearbyProjectData,
    projectArticleData,
    canonicalLink,
    error,
  };
};

export default PropertyPage;
